import { sort } from '../../utils/arrays'
import * as API from '../../utils/api'
import { buildIndex } from '../../utils/indexing'
import { getTable as getTableSub } from '../../utils/databases'

const CREATE = 'CREATE_DATABASE'
const FETCH = 'FETCH_DATABASES'

const INITIAL_STATE = {
  databases: {},
  loading: false,
}

export default (state = INITIAL_STATE, action) => {
  if (action.type === `${FETCH}_PENDING`) {
    return { ...state, loading: true }
  }

  if (action.type === `${FETCH}_REJECTED`) {
    return { ...state, loading: false }
  }

  if (action.type === `${FETCH}_FULFILLED`) {
    let databases = action.payload.data

    return {
      ...state,
      databases: {
        ...state.databases,
        ...buildIndex(databases, database => database.id),
      },
      loading: false,
    }
  }

  if (action.type === `${CREATE}_FULFILLED`) {
    let database = action.payload.data

    return {
      ...state,
      databases: {
        ...state.databases,
        [database.id]: database,
      },
    }
  }

  return state
}

// Actions

export const fetchDatabases = organizationId => ({
  type: FETCH,
  payload: API.fetchDatabases(organizationId),
})

export const createDatabase = (organizationId, values) => ({
  type: CREATE,
  payload: API.createDatabase(organizationId, values),
})

// Selectors

export const getDatabase = id => state => {
  return state.databases.databases[id]
}

export const getDatabases = organizationId => state => {
  let databases = Object.values(state.databases.databases).filter(
    database => database.OrganizationId === organizationId
  )

  // Sort alphabetically
  return sort(databases, database => database.name)
}

export const getTable = (databaseId, tableName) => state => {
  let database = getDatabase(databaseId)(state)

  return database && getTableSub(database, tableName)
}

export const getLoading = state => {
  return state.databases.loading
}
